export const ActionType = {
  SetUserInfo: Symbol("SetUserInfo"),
  Logout: Symbol("Logout"),
};
